import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HeaderMenuState } from './header-menu.state';
import { StatusEnum } from '../../core/enums/status-enum';
import { AccountRoles } from '../../shared/constants/account-roles.enum';

@Injectable()
export class HeaderService {
  private headerSubject = new Subject<HeaderMenuState>();
  headerMenuState = this.headerSubject.asObservable();
  userRoles = AccountRoles;

  setMenuState(userRole: string, requestStatus: StatusEnum, pageMode: string) {
    if (pageMode === 'list') {
      this.headerSubject.next({listActive: true, dealActive: false} as HeaderMenuState);
    } else if (pageMode === 'freight-post-request') {
      this.headerSubject.next({freightPostRequestListActive: true, listActive: false, dealActive: false} as HeaderMenuState);
    } else if (pageMode === 'deal') {
      this.headerSubject.next({listActive: false, dealActive: true} as HeaderMenuState);
    } else if (pageMode === 'carrier-list') {
      this.headerSubject.next({carrierListActive: true} as HeaderMenuState);
    } else if (pageMode === 'shipper-list') {
      this.headerSubject.next({shipperListActive: true} as HeaderMenuState);
    } else if (pageMode === 'transaction-history') {
      this.headerSubject.next({listActive: false, dealActive: false} as HeaderMenuState);
    } else if (pageMode === 'freight-post') {
      this.headerSubject.next({freightPostsActive: true} as HeaderMenuState);
    } else if (pageMode === 'freight-post-search') {
      this.headerSubject.next({freightPostSearchActive: true} as HeaderMenuState);
    } else {
      if (pageMode !== 'refund' && pageMode !== 'penalty') {
        if (this.userRoles.Carrier === userRole.toLocaleLowerCase()) {
          if (requestStatus === StatusEnum.Active) {
            this.headerSubject.next({listActive: true, dealActive: false} as HeaderMenuState);
          } else {
            this.headerSubject.next({listActive: false, dealActive: true} as HeaderMenuState);
          }
        } else {
          // Shipper and Customer Service
          if (requestStatus === StatusEnum.Active
            || requestStatus === StatusEnum.Cancelled
            || requestStatus === StatusEnum.Expired
            || requestStatus === StatusEnum.Matched
            || requestStatus === StatusEnum.DealExpired
            || requestStatus === StatusEnum.ShipperExitedDealBeforePayment
            || requestStatus === StatusEnum.CarrierExitedDealBeforePayment
            || requestStatus === StatusEnum.ShipperExitedDealInPaymentPending
            || requestStatus === StatusEnum.CarrierExitedDealInPaymentPending) {
            this.headerSubject.next({listActive: true, dealActive: false} as HeaderMenuState);
          } else {
            this.headerSubject.next({listActive: false, dealActive: true} as HeaderMenuState);
          }
        }
      } else {
        this.headerSubject.next({listActive: false, dealActive: false} as HeaderMenuState);
      }
    }
  }
}
